export default __webpack_public_path__ + "static/media/file-folder-icon.27719490.svg";